import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

const TokenExpiredError = ({ message, supplierContact }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <AlertCircle className="text-red-600" size={32} />
                </div>

                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                    Session Expired
                </h1>

                <p className="text-gray-600 mb-6">
                    {message || 'Your session link has expired or is invalid.'}
                </p>

                <div className="mb-6">
                    <Link
                        to="/order/login"
                        className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-bold text-white bg-cyan-600 hover:bg-cyan-700 rounded-xl transition-colors shadow-sm shadow-cyan-100"
                    >
                        Go to Login Page
                    </Link>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                    <p className="text-sm text-blue-800 font-medium mb-2">
                        What to do next?
                    </p>
                    <p className="text-sm text-blue-700">
                        Please contact your supplier to receive a new link.
                    </p>
                    {supplierContact && (
                        <p className="text-sm text-blue-700 mt-2 font-medium">
                            Contact: {supplierContact}
                        </p>
                    )}
                </div>

                <div className="text-xs text-gray-500">
                    For security reasons, session links expire after a certain period.
                </div>
            </div>
        </div>
    );
};

export default TokenExpiredError;
